
// Get tailor productivity data based on orders count
export const getTailorProductivity = (tailors: any[], filteredOrders: any[]) => {
  if (!tailors?.length) {
    return [];
  }

  return tailors.map(tailor => {
    // Filter orders for this tailor with null safety
    const tailorOrders = (filteredOrders || []).filter(order => 
      order?.tailor_id === tailor.id
    );
    
    const completedOrders = tailorOrders.filter(order => 
      order?.status === "completed"
    ).length;
    
    const pendingOrders = tailorOrders.filter(order => 
      order?.status === "pending" || order?.status === "saved"
    ).length;
    
    const inProgressOrders = tailorOrders.filter(order => 
      order?.status === "in-progress" || order?.status === "in_progress"
    ).length;
    
    const totalOrders = tailorOrders.length;
    
    // Calculate productivity based on completed orders percentage
    const productivity = totalOrders > 0 ? Math.round((completedOrders / totalOrders) * 100) : 0;
    
    // Get tailor name from profile if available with null safety
    const profile = tailor.profile || {};
    let name = "Unknown Tailor";
    
    if (profile.firstName || profile.lastName) {
      name = [profile.firstName, profile.lastName].filter(Boolean).join(' ');
    } else if (tailor.email) {
      name = tailor.email.split('@')[0];
    }
    
    return {
      id: tailor.id,
      name,
      completedOrders,
      pendingOrders,
      inProgressOrders,
      totalOrders,
      productivity,
    };
  })
  .filter(tailor => tailor.totalOrders > 0) // Only show tailors with orders
  .sort((a, b) => b.totalOrders - a.totalOrders); // Sort by total orders count
};
